import axios from "axios";
import { request } from "../api/api";

export const downloadFile = async (url, method = "GET", data = null) => {
  try {
    const config = {
      responseType: "blob", // This is crucial for handling binary data
    };
    let response;
    if (method.toLowerCase() === "get") {
      response = await request.get(url, config);
    } else if (method.toLowerCase() === "post") {
      response = await request.post(url, data, config);
    } else {
      throw new Error(`Unsupported method: ${method}`);
    }
    return response;
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
};

export const downloadBinaryFile = (response,fileName) => {
  if (response && response.data) {
    const contentDisposition = response.headers["content-disposition"];
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1];
      }
    }

    const fileUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};
